<script>
    import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
    import DadosProjetosDebito from './compartilhado/FormDadosProjetosDebito.vue';
    import DadosProjetosCredito from './compartilhado/FormDadosProjetosCredito.vue';

    import solicitacaoTransferenciaServico from '../servico';
    import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
    import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';

    export default {
        components: { DadosCadastrais, DadosProjetosDebito, DadosProjetosCredito, AdicionarArquivos, ListaDeArquivos },
        data() {
            return {
                solicitacao: this.camposSolicitacao(),
                carregando: false,
                configuracao: this.$storage.configuracao(),
                arquivos: [],
                contasCredito: [],
                contasDebito: [],
            }
        },
        mounted() {
            this.$root.tituloDaPagina = `Solicitação de Transferência - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
            this.$root.botaoAcaoTexto = 'Nova';
            this.$root.botaoAcaoIcon = 'fa-plus';
            this.$root.botaoAcaoLink = 'solicitacao-transferencia.nova';
        },
        methods: {
            salvar() {
                $('#salvar').button('loading');

                this.$refs.dadosCadastrais
                    .validar()
                    .then(valido => {
                        if (!valido) {
                            $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                            throw new Error("validacao");
                        }

                        return valido;
                    })
                    .then(this.$refs.dadosProjetosDebito.validarRateioProjeto)
                    .then(valido => {
                        if (!valido) {
                            $('#tabs a[href="#tab-dados-projetos-debito"]').tab('show');

                            this.$swal(
                                '',
                                'A solicitação deve possuir pelo menos um rateio de débito.',
                                'info'
                            );

                            throw new Error("validacao");
                        }

                        return valido;
                    })
                    .then(this.$refs.dadosProjetosCredito.validarRateioProjeto)
                    .then(valido => {
                        if (!valido) {
                            $('#tabs a[href="#tab-dados-projetos-credito"]').tab('show');

                            this.$swal(
                                '',
                                'A solicitação deve possuir pelo menos um rateio de crédito.',
                                'info'
                            );

                            throw new Error("validacao");
                        }

                        return valido;
                    })
                    .then(this.validarRateio)
                    .then(valido => {
                        if (!valido) {
                            throw new Error("validacao");
                        }

                        return valido;
                    })
                    .then(this.enviar)
                    .then(id => {
                        this.$imprimirRelatorio('solicitacao-transferencia.relatorio', id, 'solicitacao-transferencia');
                    })
                    .catch(erro => {
                        $('#salvar').button('reset');
                        this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
                    });
            },
            enviar(valido) {
                if (!valido) throw new Error("validacao com erro");

                const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

                copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;

                if (this.$route.params.id) {
                    return solicitacaoTransferenciaServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.id);
                } else {
                    return solicitacaoTransferenciaServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
                }
            },
            mostrarInstrucoes() {
                if (!this.configuracao.instrucoesSolTransferencia || this.$route.params.id) return;

                this.$swal({
                    title: 'Instruções da solicitação',
                    html: this.configuracao.instrucoesSolTransferencia.replace(/\r\n/g, '<br>'),
                    type: 'info',
                    confirmButtonText: 'Ok, entendi!',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            },
            listaContasCredito() {
                return solicitacaoTransferenciaServico
                    .contas(1)
                    .then(contas => {
                        this.contasCredito = contas;
                    });
            },
            listaContasDebito() {
                return solicitacaoTransferenciaServico
                    .contas(2)
                    .then(contas => {
                        this.contasDebito = contas;
                    });
            },
            camposSolicitacao() {
                return {
                    idSolicitacaoTransferencia: null,
                    dataSolicitacao: null,
                    dataTransferencia: '',
                    documento: null,
                    idContaDebito: null,
                    idContaCredito: null,
                    observacao: null,
                    formaPagamento: 3,
                    statusSolicitacao: null,
                    dataLiberacao: null,
                    observacaoLiberacao: null,
                    idUsuario: null,
                    idProtocolo: null,
                    idUsuarioLiberacao: null,
                    justificativa: null,
                    idCategoriaFinanceiraDebito: null,
                    idCategoriaFinanceiraCredito: null,
                    idLancamentoDebito: null,
                    idSetorSolicitacao: null,
                    valorTransferencia: null,
                    dataCancelamento: null,
                    complementoTransferencia: null,
                    statusSolicitacao2: null,
                    dataLiberacao2: null,
                    observacaoLiberacao2: null,
                    idUsuarioLiberacao2: null,
                    motivoCorrecao: null,
                    contaCredito: {
                        id: null,
                        nome: null,
                    },
                    contaDebito: {
                        id: null,
                        nome: null,
                    },
                    solTransRateioCredito: [],
                    solTransRateioDebito: [],
                };
            },
            carregar(id) {
                this.carregando = true;

                let solicitacao = null;

                solicitacaoTransferenciaServico
                    .obterPorId(id)
                    .then(dados => {
                        solicitacao = dados;
                    })
                    .then(() => this.$refs.dadosProjetosDebito.listaDeProjetos(solicitacao.idContaDebito))
                    .then(() => this.$refs.dadosProjetosCredito.listaDeProjetos(solicitacao.idContaCredito))
                    .then(() => {
                        $('#conta_debt').val(solicitacao.idContaDebito).select2();
                        this.$refs.dadosProjetosDebito.iniciarSelect2Conta();
                        this.$refs.dadosProjetosDebito.limparRateio();

                        $('#conta').val(solicitacao.idContaCredito).select2();
                        this.$refs.dadosProjetosCredito.iniciarSelect2Conta();
                        this.$refs.dadosProjetosCredito.limparRateio();
                    })
                    .then(() => {
                        solicitacao.dataTransferencia = this.$options.filters.formatarNumeroEmData(solicitacao.dataTransferencia);
                    })
                    .then(() => solicitacaoTransferenciaServico.arquivos(id))
                    .then(arquivos => {
                        this.arquivos = arquivos;
                    })
                    .then(() => {
                        this.$set(this, 'solicitacao', solicitacao);
                        this.carregando = false;
                    });
            },
            download(arquivo) {
                solicitacaoTransferenciaServico
                    .download(this.$route.params.id, arquivo)
                    .then(arquivo => {
                        arquivo.download();
                    });
            },
            resetarComponente() {
                Object.assign(this.$data, this.$options.data.apply(this));
            },
            total: function(rateio) {
                return rateio.reduce((somatorio, item) => {
                    const valorEstimado = this.$options.filters.formatarNumero(item.valorRateio, true);
                    return somatorio + valorEstimado
                }, 0);
            },
            validarRateio() {
                if ((this.solicitacao.solTransRateioCredito != null) & (this.solicitacao.solTransRateioDebito != null)) {
                    let valorCredito = this.total(this.solicitacao.solTransRateioCredito);
                    let valorDebito = this.total(this.solicitacao.solTransRateioDebito);

                    if (valorCredito == valorDebito) return true;
                }

                this.$swal(
                    '',
                    'A solicitação deve possuir o mesmo valor de rateio. Verifique o valor do rateio de crédito e débito.',
                    'info'
                );

                throw new Error("validacao");
            }
        },
        created() {
            this.listaContasCredito();
            this.listaContasDebito();

            if (!this.configuracao.selecaoDeContaWeb) {

                if (this.$refs.dadosProjetosDebito)
                    this.$refs.dadosProjetosDebito.listaDeProjetos(0);

                if (this.$refs.dadosProjetosCredito)
                    this.$refs.dadosProjetosCredito.listaDeProjetos(0);
            }

            if (this.$route.params.id) {
                this.carregar(this.$route.params.id);
            } else {
                this.mostrarInstrucoes();
            }
        },
        watch: {

        }
    }
</script>

<template>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
        <form @submit.prevent="validarBeneficiario">

            <div class="row">
                <div class="col-xs-12">
                    <div class="ibox float-e-margins" v-if="carregando">
                        <div class="ibox-content">
                            <p class="text-center">
                                <i class='fa fa-spinner fa-pulse'></i> Carregando...
                            </p>
                        </div>
                    </div>

                    <div class="tabs-container" v-show="!carregando" id="tabs">

                        <ul class="nav nav-tabs">
                            <li class="active">
                                <a data-toggle="tab"
                                   href="#tab-dados-cadastrais">
                                    Dados cadastrais
                                </a>
                            </li>
                            <li>
                                <a data-toggle="tab"
                                   href="#tab-dados-projetos-debito">
                                    Projetos débito
                                </a>
                            </li>
                            <li>
                                <a @click.prevent=""
                                   data-toggle="tab"
                                   href="#tab-dados-projetos-credito">
                                    Projetos crédito
                                </a>
                            </li>
                            <li v-if="configuracao.usarArquivosSolicitacaoTransferencia">
                                <a data-toggle="tab"
                                   href="#tab-adicionar-arquivos">
                                    Adicionar arquivos
                                </a>
                            </li>
                            <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoTransferencia">
                                <a data-toggle="tab"
                                   href="#tab-lista-arquivos">
                                    Arquivos
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">

                            <div id="tab-dados-cadastrais" class="tab-pane active">
                                <div class="panel-body">
                                    <dados-cadastrais ref="dadosCadastrais"
                                                      :solicitacao="solicitacao"
                                                      :edicao="!!$route.params.id">
                                    </dados-cadastrais>
                                </div>
                            </div>

                            <div id="tab-dados-projetos-debito" class="tab-pane">
                                <div class="panel-body">
                                    <dados-projetos-debito ref="dadosProjetosDebito"
                                                           :solicitacao="solicitacao"
                                                           :contas="contasDebito"
                                                           :edicao="!!$route.params.id">
                                    </dados-projetos-debito>
                                </div>
                            </div>

                            <div id="tab-dados-projetos-credito" class="tab-pane">
                                <div class="panel-body">
                                    <dados-projetos-credito ref="dadosProjetosCredito"
                                                            :solicitacao="solicitacao"
                                                            :contas="contasCredito"
                                                            :edicao="!!$route.params.id">
                                    </dados-projetos-credito>
                                </div>
                            </div>

                            <div id="tab-adicionar-arquivos" class="tab-pane">
                                <div class="panel-body">
                                    <adicionar-arquivos ref="adicionarArquivos">
                                    </adicionar-arquivos>
                                </div>
                            </div>

                            <div id="tab-lista-arquivos" class="tab-pane">
                                <div class="panel-body">
                                    <lista-de-arquivos :arquivos="arquivos"
                                                       @download="download"
                                                       ref="listaArquivos">
                                    </lista-de-arquivos>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group">

                        <router-link class="btn btn-default"
                                     :to="{ name: 'solicitacao-transferencia' }"
                                     active-class="">
                            <i class="fa fa-arrow-left"></i>
                            Voltar
                        </router-link>

                        <button id="salvar"
                                type="button"
                                class="btn btn-primary"
                                @click="salvar"
                                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
                            <i class="fa fa-save"></i>
                            Salvar
                        </button>
                    </div>
                </div>
            </div>

        </form>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-transferencia/componentes/SolicitacaoTransferenciaForm.vue